var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7507 24.9779C11.6623 25.1206 11.6131 25.2847 11.6084 25.4533C11.6036 25.6218 11.6434 25.7885 11.7236 25.9362C11.8038 26.0838 11.9216 26.2069 12.0646 26.2928C12.2076 26.3786 12.3706 26.424 12.5367 26.4242H23.1556C23.2353 26.4239 23.3135 26.4452 23.3823 26.486C23.4511 26.5267 23.5078 26.5855 23.5466 26.6561C23.5854 26.7267 23.6049 26.8065 23.6029 26.8873C23.601 26.9681 23.5777 27.0469 23.5355 27.1155L13.1131 44.0491C13.0872 44.0927 13.0529 44.1305 13.0122 44.1603C12.9715 44.1901 12.9252 44.2112 12.8763 44.2223C12.8273 44.2335 12.7767 44.2345 12.7273 44.2253C12.678 44.2161 12.631 44.1969 12.5891 44.1687C8.83414 41.7071 5.95197 38.0929 4.36268 33.8527C2.77339 29.6126 2.56004 24.9682 3.75374 20.5964C4.94743 16.2247 7.48577 12.354 10.9988 9.54854C14.5119 6.7431 18.816 5.14952 23.284 5.00004C23.3502 4.99909 23.4154 5.01621 23.4728 5.0496C23.5303 5.083 23.5778 5.13144 23.6105 5.18987C23.6432 5.2483 23.6598 5.31456 23.6586 5.38172C23.6573 5.44889 23.6384 5.51449 23.6036 5.57167L11.7507 24.9779ZM35.6975 8.63987C35.6563 8.61076 35.6096 8.59056 35.5603 8.58054C35.511 8.57052 35.4602 8.57088 35.4111 8.5816C35.362 8.59232 35.3155 8.61317 35.2747 8.64286C35.2338 8.67255 35.1994 8.71044 35.1735 8.75419L24.911 25.4378C24.869 25.5062 24.8457 25.5848 24.8436 25.6654C24.8415 25.7459 24.8608 25.8256 24.8992 25.8961C24.9377 25.9666 24.9941 26.0254 25.0625 26.0664C25.1309 26.1074 25.2089 26.129 25.2883 26.1291H35.9071C36.0733 26.1294 36.2363 26.1748 36.3793 26.2606C36.5223 26.3464 36.64 26.4695 36.7203 26.6172C36.8005 26.7648 36.8403 26.9316 36.8355 27.1001C36.8308 27.2686 36.7816 27.4328 36.6931 27.5755L24.6883 47.0854C24.6601 47.1314 24.6449 47.1844 24.6441 47.2386C24.6434 47.2927 24.6573 47.3461 24.6842 47.3929C24.7112 47.4396 24.7502 47.4781 24.7971 47.504C24.844 47.5299 24.897 47.5424 24.9503 47.54C29.349 47.3237 33.5691 45.7082 37.0128 42.9225C40.4564 40.1368 42.9489 36.3221 44.1372 32.0188C45.3256 27.7156 45.1494 23.142 43.6337 18.946C42.118 14.75 39.3397 11.1443 35.6923 8.63987H35.6975Z",
    fill: "url(#paint0_linear_610_76)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_76",
    x1: 21.0937,
    y1: 13.7792,
    x2: 28.6717,
    y2: 45.8638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00F8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0096D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0016D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0000D5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.41db808c.svg";
export { ForwardRef as ReactComponent };